function validateCPF(string) {
    var cpf = string.replace(/[^\d]+/g, '');
    if (cpf === '')
        return false;
    if (cpf.length !== 11 ||
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999')
        return false;
    var add = 0;
    for (var i = 0; i < 9; i++)
        add += parseInt(cpf.charAt(i), 10) * (10 - i);
    var rev = 11 - (add % 11);
    if (rev === 10 || rev === 11)
        rev = 0;
    if (rev !== parseInt(cpf.charAt(9), 10))
        return false;
    add = 0;
    for (var i = 0; i < 10; i++)
        add += parseInt(cpf.charAt(i), 10) * (11 - i);
    rev = 11 - (add % 11);
    if (rev === 10 || rev === 11)
        rev = 0;
    if (rev !== parseInt(cpf.charAt(10), 10))
        return false;
    return true;
}
function validatePassword(password) {
    var passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
    return passwordRegex.test(password);
}
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
function validatePhone(phone) {
    var numericPhone = phone.replace(/\D/g, '');
    if (numericPhone.length < 10 || numericPhone.length > 11) {
        return false;
    }
    var repeatedDigitsRegex = /^(?:(\d)\1{2,10})$/;
    if (repeatedDigitsRegex.test(numericPhone)) {
        return false;
    }
    var ddd = numericPhone.substring(0, 2);
    var numericDdd = parseInt(ddd, 10);
    if ((numericDdd < 11)) {
        return false;
    }
    return true;
}
function validateCNPJ(string) {
    var cnpj = string.replace(/[^\d]+/g, '');
    if (cnpj.length !== 14)
        return false;
    if (cnpj === '00000000000000' ||
        cnpj === '11111111111111' ||
        cnpj === '22222222222222' ||
        cnpj === '33333333333333' ||
        cnpj === '44444444444444' ||
        cnpj === '55555555555555' ||
        cnpj === '66666666666666' ||
        cnpj === '77777777777777' ||
        cnpj === '88888888888888' ||
        cnpj === '99999999999999')
        return false;
    // Validação do primeiro dígito verificador
    var sum = 0;
    var weight = 5;
    for (var i = 0; i < 12; i++) {
        sum += parseInt(cnpj.charAt(i)) * weight;
        weight = weight === 2 ? 9 : weight - 1;
    }
    var digit = 11 - (sum % 11);
    if (digit >= 10) {
        digit = 0;
    }
    if (digit !== parseInt(cnpj.charAt(12))) {
        return false;
    }
    // Calcula o segundo dígito verificador
    sum = 0;
    weight = 6;
    for (var i = 0; i < 13; i++) {
        sum += parseInt(cnpj.charAt(i)) * weight;
        weight = weight === 2 ? 9 : weight - 1;
    }
    digit = 11 - (sum % 11);
    if (digit >= 10) {
        digit = 0;
    }
    if (digit !== parseInt(cnpj.charAt(13))) {
        return false;
    }
    return true;
}
function validateRG(string) {
    var rg = string.replace(/[^\d]/g, '');
    // Verifica se o número tem menos de 5 dígitos
    if (rg.length < 5) {
        return false;
    }
    if (!verificaSequencia(rg)) {
        return false;
    }
    return true;
    function verificaSequencia(rg) {
        // Verifica se todos os caracteres são iguais
        var allSame = rg.split('').every(function (char) { return char === rg[0]; });
        if (allSame)
            return false;
        // Verifica se os caracteres são uma sequência crescente ou decrescente
        var isSequential = function (rg) {
            var nums = rg.split('').map(function (num) { return parseInt(num, 10); });
            return nums.every(function (num, i, arr) {
                if (i === 0)
                    return true;
                return (num === arr[i - 1] + 1) || (num === arr[i - 1] - 1) || (num === 0 && arr[i - 1] === 9) || (num === 1 && arr[i - 1] === 0);
            });
        };
        if (isSequential(rg))
            return false;
        return true;
    }
}
function validateCEP(string) {
    // Remove qualquer caractere que não seja número
    var cep = string.replace(/\D/g, '');
    // Verifica se o cep tem exatamente 8 dígitos
    if (cep.length !== 8) {
        return false;
    }
    // Verifica se o cep começa com '00', o que não é permitido
    if (cep.startsWith('00')) {
        return false;
    }
    return true;
}
function validateBankAgency(string) {
    var agency = string.replace(/\D/g, '');
    if (/^0+$/.test(agency)) {
        return false;
    }
    return true;
}
function validateAccountNumber(string) {
    var Account = string.replace(/\D/g, '');
    if (Account.length < 4 || Account.length > 12) {
        return false;
    }
    if (/^0+$/.test(Account)) {
        return false;
    }
    return true;
}
function isFaceLikelyFalsePositive(face) {
    // if (!face || !face.keypoints) return false;
    var rightEye = face.keypoints.find(function (k) { return k.name === 'rightEye'; });
    var leftEye = face.keypoints.find(function (k) { return k.name === 'leftEye'; });
    var nose = face.keypoints.find(function (k) { return k.name === 'noseTip'; });
    var mouth = face.keypoints.find(function (k) { return k.name === 'mouthCenter'; });
    if (!rightEye || !leftEye || !nose || !mouth) {
        return true;
    }
    var distance = function (a, b) { return Math.hypot(a.x - b.x, a.y - b.y); };
    var eyeCenter = {
        x: (rightEye.x + leftEye.x) / 2,
        y: (rightEye.y + leftEye.y) / 2
    };
    var eyeDistance = distance(rightEye, leftEye);
    if (eyeDistance === 0) {
        return true;
    }
    var noseHorizontalDeviation = Math.abs(nose.x - eyeCenter.x) /
        eyeDistance;
    var mouthHorizontalDeviation = Math.abs(mouth.x - eyeCenter.x) /
        eyeDistance;
    var eyeToNose = distance(eyeCenter, nose) /
        eyeDistance;
    var score = 0;
    // Nariz muito deslocado horizontalmente
    if (noseHorizontalDeviation > 0.10) {
        score++;
    }
    // Boca muito deslocada horizontalmente
    if (mouthHorizontalDeviation > 0.10) {
        score++;
    }
    // Relação olhos -> nariz muito fora do intervalo
    if (eyeToNose < 0.35 ||
        eyeToNose > 0.75) {
        score++;
    }
    // console.log({
    //   noseHorizontalDeviation,
    //   mouthHorizontalDeviation,
    //   eyeToNose,
    //   score
    // });
    /*
    * score 0 - Detecção considerada geometricamente normal.
    * score 1 - Detecção considerada geometricamente normal, mas com alguma suspeita.
    * score 2 - Detecção considerada geometricamente suspeita, considerado falso positivo.
    * score 3 - Detecção considerada falso positivo, com todas as verificações apresentando inconsistências.
    */
    return score >= 2;
}
export default { validateCPF: validateCPF, validateEmail: validateEmail, validatePassword: validatePassword, validatePhone: validatePhone, validateCNPJ: validateCNPJ, validateRG: validateRG, validateCEP: validateCEP, validateBankAgency: validateBankAgency, validateAccountNumber: validateAccountNumber, isFaceLikelyFalsePositive: isFaceLikelyFalsePositive };
